// extracted by mini-css-extract-plugin
export default {"styleChooserSection":"s3-z","dimensionLabel":"t3-z","styleChooserControlWrapper":"u3-z","styleChooserControl":"v3-z","disabled":"w3-z","giftCard":"x3-z","styleChooserText":"y3-z"};